import styled from 'styled-components';

export const Overlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 58px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 430px;
  height: calc(100dvh - 58px);
  z-index: 998;
  background: rgba(0, 0, 0, 0.3);

  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  transition: opacity 0.3s ease;

  @media (min-width: 1024px) {
    max-width: 600px;
  }
`;

export const OverlayInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const MenuContainer = styled.aside<{ $isOpen: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;

  width: 100%;
  max-width: 430px;
  background: #fff;
  z-index: 999;
  padding: 20px 24px;

  display: flex;
  flex-direction: column;

  transform: translate3d(${({ $isOpen }) => ($isOpen ? '0' : '100%')}, 0, 0);
  transition: transform 0.3s ease;
  will-change: transform;

  @media (min-width: 1024px) {
    max-width: 600px;
  }
`;

export const MenuHeader = styled.div`
  font-size: 24px;
  font-weight: 700;
`;

export const MenuCustomerBlock = styled.div`
  padding-bottom: 15px;
  border-bottom: 1px solid #e6ebf4;
  margin-bottom: 15px;
`;

export const MenuNameBlock = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 4px;
`;

export const MenuPhoneBlock = styled.div`
  font-size: 14px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
`;

export const MenuContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  gap: 15px;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 0px;
  cursor: pointer;

  img:last-child {
    margin-left: auto;
  }
`;

export const MenuIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MenuText = styled.span`
  font-size: 18px;
  color: #0f0f0f;
  font-weight: 600;
  line-height: 24px;
`;

export const SignOutButton = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  color: #636a70;
`;
